module.exports = __webpack_public_path__ + "img/koishi komeiji_lw.1155b250.png";